const dataTypes = [
  { value: "decimal", label: "Decimal" },
  { value: "text-area", label: "Text Area" },
  { value: "string", label: "String" },
  { value: "date", label: "Date" },
  { value: "list", label: "List" },
]

export default dataTypes
